<template>
  <div class="user">
    <div>
      <NavBar :narBarTitle="$t('个人信息')" class="barTitle" @click-left="onClickLeft" />
      <div class="user-item">
        <div class="user-item-left">
          <div class="user-item-font">{{ $t('头像') }}</div>
        </div>
        <van-field class="space" input-align="right">
          <template #input>
            <div class="cropper">
              <img :src="avatar" class="img" />
              <!-- option是配置，格式是对象，getbase64Data是组件的一个方法获取裁剪完的头像 2.14新增一个获取getblobData的方法 -->
              <h5-cropper :option="option"
                @getFile="getFile"></h5-cropper>
            </div>
          </template>
        </van-field>
      </div>
      <div class="user-item" @click="toPersionalName">
        <div class="user-item-left">
          <div class="user-item-font">{{ $t('姓名') }}</div>
        </div>
        <div class="nameText">{{ userName }}</div>
        <van-icon name="arrow" color="#999999" />
      </div>
      <div class="user-item" @click="toNickName" :key="nickName">
        <div class="user-item-left">
          <div class="user-item-font">{{ $t('昵称') }}</div>
        </div>
        <div class="nameText">{{ nickName }}</div>
        <van-icon name="arrow" color="#999999" />
      </div>
      <div class="user-item" @click="toPersionalEmail">
        <div class="user-item-left">
          <div class="user-item-font">{{ $t('邮箱') }}</div>
        </div>
        <div class="nameText">{{ email }}</div>
        <van-icon name="arrow" color="#999999" />
      </div>
      <div class="user-item-last">
        <div class="user-item-right">
          <div class="user-item-font">{{ $t('部门') }}</div>
        </div>
        <span class="versionText">{{ departmentName }}</span>
      </div>
      <div class="user-item-last">
        <div class="user-item-right">
          <div class="user-item-font">{{ $t('职务') }}</div>
        </div>
        <span class="versionText">{{ jobTitle }}</span>
      </div>
      <div class="user-item-last">
        <div class="user-item-right">
          <div class="user-item-font">{{ $t('角色') }}</div>
        </div>
        <span class="versionText">{{ Role }}</span>
      </div>
    </div>
    <TabBar />
  </div>
</template>
<script>
import TabBar from '@/components/tabBar'
import NavBar from '@/components/navBar'
import Vue from 'vue'
import { Image, Field, Toast } from 'vant'
import {
  getStaffById,
  queryStaffToekn,
  upload,
  postUserInfo,
} from '@/services/api'
import H5Cropper from 'vue-cropper-h5'

Vue.component(Field.name, Field)
Vue.use(H5Cropper)
Vue.use(Image)
Vue.use(Toast)

export default {
  name: 'PersionInfo',
  components: {
    TabBar,
    NavBar,
  },
  data() {
    return {
      user: {},
      userName: '',
      department: '',
      company: '',
      avatar: '',
      version: process.env.VUE_APP_VERSION,
      visitorName: '',
      departmentName: '',
      Role: '',
      RoleId: '',
      jobTitle: '',
      email: '',
      nickName: '',
      newUser: {},
      res: {},
      facePhoto: '',
      option: {
        confirmButtonBackgroundColor: '#009BFF',
        cancelButtonText:this.$t('取消'),
        confirmButtonText:this.$t('确认'),
      },
      facePhoto: '',
    }
  },
  methods: {
    async getFile(data) {
      const formData = new FormData()
      formData.append('file', data)
      try {
        const res = await upload(formData)
        this.avatar = res
        await postUserInfo({
          id: this.user.id,
          faceUrl: this.avatar,
          companyId: this.user.companyId,
          roleId: this.RoleId,
          facePhoto: this.facePhoto,
        })
        await queryStaffToekn({ token: this.user.token })
        Toast(this.$t('修改成功'))
      } catch (error) {
        this.avatar = ''
        Toast.fail(this.$t('照片上传失败! 您需重新上传'))
      }
    },
    onClickLeft() {
      this.$router.push('/user')
    },
    toPersionalName() {
      this.$router.push('/persionalName')
    },
    toNickName() {
      this.$router.push('/nickName')
    },
    toSetting() {
      this.$router.push('/setting')
    },
    toFaceCollection() {
      this.$router.push('/faceCollection')
    },
    toAddressBook() {
      this.$router.push('/addressBook')
    },
    toElectronickey() {
      this.$router.push('/electronickey')
    },
    toPersionInfo() {
      this.$router.push('/persionInfo')
    },
    toPersionalEmail() {
      this.$router.push('/persionalEmail')
    },

    async fetchUserData() {
      this.user = JSON.parse(localStorage.getItem('user'))
      this.res = await getStaffById(this.user.id)
      this.newUser = await queryStaffToekn({ token: this.user.token })
      this.userName = this.res.name
      if (this.res.roleList && this.res.roleList.length > 0) {
        this.Role = this.res.roleList.map((item) => item.name).join('/')
      } else {
        this.Role = ''
      }
      this.RoleId = this.res.roleList.map((item) => item.id).join(',')
      this.departmentName = this.res.departmentName || this.$t('暂无')
      this.nickName = this.$route.params.nickName || this.res.nickName || ''
      this.facePhoto = this.res.facePhoto || this.$t('暂无')
      this.jobTitle = this.res.jobPost || this.$t('暂无')
      this.avatar = this.res.faceUrl || require('@/assets/images/icon.png')
      this.email = this.$route.params.email || this.res.email
      this.facePhoto = this.res.facePhoto || ''
    },
  },
  mounted() {
    this.fetchUserData()
    this.user = JSON.parse(localStorage.getItem('user'))
    this.company = this.user.companyName
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.name !== undefined) {
      this.userName = to.params.name || ''
    }
    if (to.params.email !== undefined) {
      this.email = to.params.email || ''
    }
    if (to.params.nickName !== undefined) {
      this.nickName = to.params.nickName || this.nickName
    }
    next()
  },
  watch: {
    userName(newName) {
      this.userName = newName
    },
    email(newName) {
      this.email = newName
    },
    nickName(newName) {
      this.nickName = newName
    },
  },
}
</script>
<style lang="less" scoped>
.nameText {
  width: 100%;
  font-size: 16px;
  margin-left: 30px;
}

.user {
  height: 100%;

  .user-item {
    height: 56px;
    background: #fefffe;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px;

    &:not(:last-child) {
      border-bottom: 1px solid #ebebeb;
    }

    .user-item-left {
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 24px;

      .user-item-font {
        padding-left: 8px;
        white-space: nowrap;
      }
    }
  }
}

.user-item-last {
  height: 56px;
  background: #fefffe;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 32px;
  font-size: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
  }

  .user-item-right {
    padding-right: 32px;
  }
}

.avatar-button {
  position: relative;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
}

.avatar-button::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
}

.avatar-button::after {
  content: '\f1c5';
  font-family: 'fontawesome';
  font-size: 18px;
  line-height: 40px;
  color: #ccc;
  text-align: center;
}

.cropper {
  width: 40px;
  height: 40px;
  // line-height: 40px;
  /* 切记position: relative一定要有 */
  position: relative;
  text-align: center;

  .img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 50%;
  }
}

.van-cell {
  padding: 0px 0px;
}
</style>
